import { render, staticRenderFns } from "./routeDetail.vue?vue&type=template&id=061b443b&scoped=true&"
import script from "./routeDetail.vue?vue&type=script&lang=js&"
export * from "./routeDetail.vue?vue&type=script&lang=js&"
import style0 from "./routeDetail.vue?vue&type=style&index=0&id=061b443b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061b443b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('061b443b')) {
      api.createRecord('061b443b', component.options)
    } else {
      api.reload('061b443b', component.options)
    }
    module.hot.accept("./routeDetail.vue?vue&type=template&id=061b443b&scoped=true&", function () {
      api.rerender('061b443b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/routeBooking/routeDetail.vue"
export default component.exports